//#region src/assets/email-unread.svg
var email_unread_default = "" + new URL("email-unread-B4glWliu.svg", import.meta.url).href;
//#endregion
export { email_unread_default as default };

//# sourceMappingURL=email-unread.js.map